import React, { memo } from 'react'
import { Paper } from 'transfix-ui/core'
import {
  ExtendedScorecard,
  IExtendedScorecardProps,
} from '../ExtendedCarrierScorecard/ExtendedScorecard'

export interface IBorderedCarrierScorecardProps extends IExtendedScorecardProps {}

export const BorderedCarrierScorecard = memo<IBorderedCarrierScorecardProps>(({ ...props }) => {
  return (
    <Paper>
      <ExtendedScorecard className='wrapped' {...props} />
    </Paper>
  )
})

export default BorderedCarrierScorecard
